import React, { useState, useEffect } from 'react'
import moment from 'moment'
import API from '../../../../../services/API'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import AddQualification from './AddQualification'
// MUI Imports
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

const QualificationsTab = ({ employee }) => {
  const [qualList, setQualList] = useState([])
  const [selectedQualification, setSelectedQualification] = useState(null)

  const getQualifications = () => {
    API.get(`/employees/qualifications?id=${employee._id}`)
      .then((res) => {
        setQualList(res.data)
      })
      .catch((e) => console.log(e))
  }
  useEffect(() => {
    getQualifications()
  }, [])

  return (
    <Stack marginTop={1}>
      <AddQualification
        employee={employee}
        setQualList={setQualList}
        selectedQualification={selectedQualification}
        setSelectedQualification={setSelectedQualification}
        getQualifications={getQualifications}
      />
      <CustomDataGrid
        rows={qualList}
        getRowId={(params) => params._id}
        onRowClick={({ row }) => setSelectedQualification(row)}
        columns={[
          {
            field: 'qualificationName',
            headerName: 'Qualification',
            flex: 1,
            minWidth: 200,
          },
          {
            field: 'qualificationDate',
            headerName: 'Date',
            minWidth: 150,
            renderCell: ({ row }) =>
              row?.qualificationDate &&
              moment(row.qualificationDate).format('DD MMM YYYY'),
          },
          {
            field: 'qualificationExpiryDate',
            headerName: 'Expiry',
            minWidth: 150,
            renderCell: ({ row }) =>
              row?.qualificationExpiryDate &&
              moment(row.qualificationExpiryDate).format('DD MMM YYYY'),
          },
        ]}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        slots={{
          footer: () => null,
          toolbar: () => null,
          noRowsOverlay: () => (
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Alert severity="info">No Qualifications</Alert>
            </Box>
          ),
          noResultsOverlay: () => (
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Alert severity="info">No Qualifications</Alert>
            </Box>
          ),
        }}
      />
    </Stack>
  )
}

export default QualificationsTab
